import {Injectable} from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import { tap } from 'rxjs/operators';
import {Config} from "../_models";
import {HttpClient} from '@angular/common/http';
import {OAuthService} from "angular-oauth2-oidc";

@Injectable({
  providedIn: 'root'
})

export class SettingsProvider {
  private config!: Config;

  constructor(private http: HttpClient, private oauth: OAuthService) {}

  public async loadConfig(): Promise<Config> {
    try {
      const env = await firstValueFrom(
        this.http.get<Config>('/assets/config/config.json')
          .pipe(tap(env => (this.config = env)))
      );
      console.log('🔧 Configuring OAuth with issuer:', env.identityServerUrl);
      this.oauth.configure({
        issuer: env.identityServerUrl,
        clientId: env.clientId,
        redirectUri: env.redirectUri,
        responseType: 'code',
        scope: env.scope,
        showDebugInformation: true,
        oidc: true,
        requestAccessToken: true,
        disableAtHashCheck: true,
        strictDiscoveryDocumentValidation: false,
        skipIssuerCheck: true,
        clearHashAfterLogin: true,
        sessionChecksEnabled: false
      });
      console.log('🔧 OAuth configured. Current issuer:', this.oauth.issuer);
      this.oauth.tokenValidationHandler = null;
      return env;
    } catch (err) {
      console.error('❌ config.json load failed', err);
      throw err; // rethrow so APP_INITIALIZER doesn't silently swallow it
    }
  }

  public get configuration(): Config {
    return this.config;
  }

  public get identityServerUrl(): string {
    return this.config.identityServerUrl;
  }
}
